import React from 'react';
import ResizeWrapper from './ResizeWrapper';
import { useProjectState } from '@starflow/app/store';

export const ResizeEditor = React.memo((props) => {
  const currentNodeId = useProjectState('currentNodeId');
  const generator = useProjectState((state) => state.nodeMap[currentNodeId]);
  return <ResizeWrapper {...props} generator={generator} />;
});
